import React, { useMemo, useCallback, memo } from 'react';
import style from "./CalendarioApp.module.css"
import { ReactComponent as TrashIcon } from "../../icons/trash.svg";

// Componente de item de agendamento extraído para melhorar a memoização
const AppointmentItem = memo(({ id, appointment, onDeleteAppointment, onAppointmentClick }) => {
  const data = useMemo(() => {
    return new Date(appointment.initial_time).toLocaleDateString("pt-BR", { timeZone: "UTC" });
  }, [appointment.initial_time]);

  const horario = useMemo(() => {
    return calcularInicioeFim(appointment.initial_time, appointment.final_time);
  }, [appointment.initial_time, appointment.final_time]);

  const handleDeleteClick = useCallback((e) => {
    e.stopPropagation();
    onDeleteAppointment(id);
  }, [id, onDeleteAppointment]);

  const handleItemClick = useCallback(() => {
    onAppointmentClick(id);
  }, [id, onAppointmentClick]);

  return (
    <div
      className={style.appointment_item}
      onClick={handleItemClick}
      style={{ borderLeft: `5px solid`, borderImage: `${appointment.linearGradient} 1` }}
    >
      <h3>{appointment.title}</h3>
      <p>{data}</p>
      <p>{horario}</p>
      <button
        className={style.delete_appointment}
        onClick={handleDeleteClick}
      >
        <TrashIcon width={15} height={15} />
      </button>
    </div>
  );
});

// Função utilitária para calcular horário - movida para fora do componente
const calcularInicioeFim = (initial_time, final_time) => {
  const initialDateObj = new Date(initial_time);
  const finalDateObj = new Date(final_time);

  const initialTime = initialDateObj.toLocaleTimeString('pt-BR', { timeZone: 'UTC', hour: '2-digit', minute: '2-digit' });
  const finalTime = finalDateObj.toLocaleTimeString('pt-BR', { timeZone: 'UTC', hour: '2-digit', minute: '2-digit' });

  const initialDate = initialDateObj.toISOString().split('T')[0];
  const finalDate = finalDateObj.toISOString().split('T')[0];

  if (initialDate === finalDate) {
    return `${initialTime} - ${finalTime}`;
  } else {
    const finalDateLocal = finalDateObj.toLocaleDateString("pt-BR", { timeZone: "UTC" });
    return `${initialTime} - ${finalTime} (${finalDateLocal})`;
  }
}


const Rightbar = memo(({ appointments, onDeleteAppointment, onAppointmentClick }) => {
  // Data atual memoizada, só calcula uma vez
  const currentDate = useMemo(() => {
  return new Date().toLocaleDateString('pt-BR', { 
      weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
      timeZone: 'UTC' 
    });
  }, []);

  // Lista de agendamentos memoizada e ORDENADA
  const appointmentItems = useMemo(() => {
    return Object.entries(appointments)
      // Adicione esta linha para ordenar os agendamentos
      .sort(([, a], [, b]) => b.initial_time.localeCompare(a.initial_time))
      .map(([id, appointment]) => (
        <AppointmentItem
          key={id}
          id={id}
          appointment={appointment}
          onDeleteAppointment={onDeleteAppointment}
          onAppointmentClick={onAppointmentClick}
        />
      ));
  }, [appointments, onDeleteAppointment, onAppointmentClick]);

  return (
    <div className={style.rightbar}>
      <h2>Agendamentos</h2>
      <div id="currentDate">{currentDate}</div>
      <div className={style.appointment_list}>
        {appointmentItems}
      </div>
    </div>
  );
});

export default Rightbar;